import m from "./ghl-ui.es1187.js";
import { createTheme as i } from "./ghl-ui.es855.js";
import s from "./ghl-ui.es1157.js";
import p from "./ghl-ui.es1166.js";
import { composite as a } from "./ghl-ui.es904.js";
const c = (t) => {
  const {
    borderRadius: r,
    boxShadow2: e,
    baseColor: o
  } = t;
  return Object.assign(Object.assign({}, m), {
    borderRadius: r,
    boxShadow: e,
    color: a(o, "rgba(0, 0, 0, .85)"),
    textColor: o
  });
}, n = i({
  name: "Tooltip",
  common: s,
  peers: {
    Popover: p
  },
  self: c
}), d = n;
export {
  d as default
};
